module.exports = __webpack_public_path__ + "static/media/mp-membertomember.3dfef0a0.png";